import SplitType from 'split-type';
import Lenis from '@studio-freight/lenis';
import imagesLoaded from 'imagesloaded';
import Typed from 'typed.js';
import Swiper from 'swiper';
import { SVGInjector } from 'svg-injector';
import Ukiyo from 'ukiyojs';
import Masonry from 'masonry-layout';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import 'bootstrap/dist/js/bootstrap.bundle';
import CountUp from '../vendor/countUp.umd.js';

window.SplitType = SplitType;
window.Lenis = Lenis;
window.imagesLoaded = imagesLoaded;
window.Typed = Typed;
window.Swiper = Swiper;
window.SVGInjector = SVGInjector;
window.Ukiyo = Ukiyo;
window.Masonry = Masonry;
window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeUI_Default = PhotoSwipeUI_Default;
window.countUp = CountUp;
